import { loadAuthClient } from "./authClientLoader";

export async function runSignOut(onLocalSignOut: () => void): Promise<void> {
  try {
    const authClient = await loadAuthClient();
    await authClient.signOut();
  } catch (error) {
    console.error("Failed to propagate sign-out to server:", error);
  } finally {
    onLocalSignOut();
  }
}
